/* Angular Component */
import {
  Component,
  Output,
  Input,
  EventEmitter,
  ElementRef,
} from "@angular/core";

@Component({
  selector: "ichannel-dropdown",
  templateUrl: "./iDropdown.component.html",
  styleUrls: ["./iDropdown.component.scss"],
})
export class iDropdownComponent {
  @Output()
  output = new EventEmitter();

  @Input()
  key = "name";

  @Input()
  initValue;

  value;

  @Input()
  label;

  @Input()
  placeholder;

  @Input()
  options;

  @Input()
  multiple = false;

  /* list of options will drop down and not up if this is set to true */
  @Input()
  listDown = false;

  /* equals to the width of the dropdown */
  @Input()
  textEllipsis: number = 0;

  listOpen = false;

  constructor(private ref: ElementRef) {}

  ngOnInit() {
    this.setupInitValue();

    //this.resetValue();
  }

  /**
   * Resetting Value
   * @return void
   */
  resetValue() {
    this.value = {
      label: "",
      data: [],
    };

    this.options.map((option, index, options) => {
      options[index]["selected"] = false;
    });
  }

  /**
   * Detect Changes and performing actions according to it
   * @param changes
   * @return void
   */
  ngOnChanges(changes) {
    if (changes["initValue"]) this.setupInitValue();
  }

  /**
   * Setup Init Value (Make changes in view according to supplied data)
   * @return void
   */
  setupInitValue() {
    /* Reset Value */
    this.resetValue();

    /* Prevent undefined iteration */
    if (typeof this.initValue == "undefined") {
      if (this.placeholder) {
        let ph = {};
        ph[this.key] = this.placeholder;
        this.assginSingleValue(ph);
      }
      return;
    }
    var mapper = {};

    /* Mapping the items */
    this.options.map(
      ((item, index) => {
        mapper[item[this.key]] = index;
      }).bind(this),
    );

    /* In case of multiple values - pushing them all */
    if (this.initValue && this.initValue instanceof Array) {
      this.initValue.forEach(
        ((item) => {
          /* Validating and Searching */
          if (typeof mapper[item[this.key]] != "undefined") {
            /* Assign Options */
            this.selectMultipleOption(
              this.options[mapper[item[this.key]]],
              mapper[item[this.key]],
            );
          }
        }).bind(this),
      );
    } else {
      // console.log("SINGLE VALUE: ", this.initValue);
      if (this.options.length > 0) {
        this.assginSingleValue(this.options[0]);
        this.options[0].selected = true;
        this.updateOutput();
      }
    }
  }

  /**
   * Opening The List
   * @return void
   */
  openList() {
    this.listOpen = !this.listOpen;
  }

  /**
   * Assign Single Value to Value Property
   * @param option
   * @return void
   */
  assginSingleValue(option) {
    this.value = {
      label: option[this.key],
      data: [option],
    };
  }

  /**
   * Selecting the option and the index
   * @param option
   * @param index
   * @return void
   */
  selectOption(option, index) {
    /* Moving forward to multiple option */
    if (this.multiple) return this.selectMultipleOption(option, index);

    this.clearOthers();

    this.options[index].selected = true;
    this.assginSingleValue(option);

    this.updateOutput();

    this.openList();
  }

  /**
   * Handler for Multiple Option Select (Toggle options)
   * @param option
   * @param index
   */
  selectMultipleOption(option, index) {
    let optionIndex = this.value.data.indexOf(option);

    /* Check if option already exist */
    if (optionIndex >= 0)
      return this.deleteMultipleOption(option, index, optionIndex);

    /* Adding the option to output value */
    this.options[index].selected = true;

    /* Adding the item to array */
    this.value.data.push(option);

    /* Updating The Label */
    this.updateValueLabel();

    this.updateOutput();
  }

  /**
   * Remove option from output value
   * @param option
   * @param index
   * @param indexOf
   * @return void
   */
  deleteMultipleOption(option, index, indexOf) {
    /* Mark selection as false */
    this.options[index].selected = false;

    /* Removing an item from splice */
    this.value.data.splice(indexOf, 1);

    /* Updating The Label */
    this.updateValueLabel();

    this.updateOutput();
  }

  /**
   * Updating Value Label
   * @return void
   */
  updateValueLabel() {
    let labelParts = [];
    let objectKey = this.key;

    this.value.data.forEach(function (item) {
      labelParts.push(item[objectKey]);
    });

    this.value.label = labelParts.join(", ");
  }

  /**
   * Updating Output
   * @return void
   */
  updateOutput() {
    if (this.options.length > 0) {
      this.output.emit(this.value);
    }
  }

  /**
   * Clearing preselected items
   * @return void
   */
  clearOthers() {
    for (var index = 0; index < this.options.length; index++)
      this.options[index].selected = false;
  }

  /**
   * Hanler for clicking outside the dropdown
   * @param event
   */
  onClickOutside(event) {
    if (!this.ref.nativeElement.contains(event.target)) {
      if (this.listOpen) this.openList();
    }
  }

  /**
   * Mapping Object to dropdown structure according to supplied title
   * @param titleKey
   * @param array
   */
  static mapObjectToDropdown(titleKey, list) {
    if (!list.forEach)
      console.info("Dropdown: List is not array. TODO: make it compatible.");

    var output = [];

    list.forEach(function (item) {
      output.push({ title: item[titleKey], model: item });
    });

    return output;
  }
}
